/*
 * @Version    : v1.00
 * @Author     : generated
 * @Date       : 2025-11-20
 * @desc       : 阿姆哈拉语<埃塞俄比亚语> 国际化语言文件
 */
// 阿姆哈拉语<埃塞俄比亚语>.js
export default {
  centerAgent: {
    subagency: 'ንዑስ-አገልግሎት',
    search: 'ፈልግ',
    subagencyIncome: 'የንዑስ-አገልግሎት ገቢ',
    last29Days: 'ያለፉት 29 ቀናት',
    excludingToday: 'ዛሬ አልባ',
    commission: 'ኮሚሽን',
    last30Days: 'የመጨረሻ 30 ቀናት ውሂብ',
    rank: 'ምድብ',
    hostNumber: 'ቁጥር አስተናጋጅ',
    recent30Days: 'የቅርብ 30 ቀናት የአስተናጋጅ ገቢ',
    commissionRate: 'ኮሚሽን ተመን',
    myCommission: 'የእኔ ኮሚሽን',
    remove: 'ማስወገድ',
    thisAction: 'ይህ እርምጃ {hostoragent} {hostname} ን ከቡድንዎ ያስወግዳል። ለመቀጠል ያረጋግጣሉ?',
    dashboard: 'ዳሽቦርድ',
    information: 'መረጃ',
    dataCenter: 'የውሂብ ማዕከል',
    hostList: 'የአስተናጋጆች ዝርዝር',
    bdList: 'የBD ዝርዝር',
    agencyList: 'የአጀንዲ ዝርዝር',
    myRight: 'የእኔ መብት',
    numberOf: 'የአጀንዲ ብዛት',
    inviteAgency: 'አጀንዲ ጋብዪ',
    numberOfHost: 'የአስተናጋጅ ብዛት',
    inviteHost: 'አስተናጋጅ ይጋብዙ',
    inviteHostlinkcopied: 'የግብዣ አገናኝ ተቀድቷል',
    tipsShare: 'ጠቃሚ ምክሮች፡ የግብዣ ሊንኩን ከጓደኞችዎ ጋር ያጋሩ',
    thisMonthD: 'የዚህ ወር ውሂብ',
    formDay1: 'ከday1 እስከ day2',
    hostGift: 'የአስተናጋጅ ስጦታ ነጥቦች',
    agentCommission: 'ወኪል ኮሚሽን',
    currentLevel: 'አሁን ያለው ደረጃ',
    commissionRateOf: 'የወኪሎች ገቢ ኮሚሽን መጠን',
    baseSalary: 'መሠረታዊ ደሞዝ',
    stillNeed: 'አሁንም ያስፈልጋል',
    toReach: 'ለማግኘት',
    reachedthe: 'ማስታወቂያ ተግባር',
    advertisementTask: 'አጠቃላይ እይታ የውሂብ',
    dataOverview: 'የውሂብ አጠቃላይ እይታ',
    today: 'ዛሬ',
    hostPoint: 'የአስተናጋጅ ነጥብ',
    agentsPoints: 'የወኪል ነጥቦች ገቢ',
    thisMonth: 'የዚህ ወር',
    month: 'ወር',
    lastMonth: 'ያለፈው ወር',
    bdNumber: 'የBD ቁጥር',
    hostIncome: 'የአስተናጋጅ ገቢ',
    todayIncome: 'የዛሬ ገቢ',
    past30Days: 'ያለፉት 30 ቀናት',
    host: 'አስተናጋጅ',
    country: 'ሀገር',
    level7: 'ደረጃ / 7-ቀን ገቢ',
    pointIncome: 'የነጥብ ገቢ',
    liveDuration: 'የቀጥታ ቆይታ',
    joinTime: 'የመግባት ጊዜ',
    state: 'ሁኔታ',
    operation: 'ክንውን',
    bd: 'BD',
    totalHosts: 'ጠቅላላ የአስተናጋጅ ገቢ',
    totalAgents: 'ጠቅላላ የወኪል ገቢ',
    agent: 'ወኪል',
    agentLevel: 'የወኪል ደረጃ / ኮሚሽን መጠን',
    commissionIncome: 'የኮሚሽን ገቢ',
    showDirect: 'ቀጥታ ወኪሎችን ብቻ አሳይ።የዛሬው ውሂብ አልተካተተም',
    excludingTodayData: 'የዛሬው ውሂብ አልተካተተም',
    packages: 'ጥቅሎች',
    contents: 'ይዘቶች',
    balance: 'ቀሪ ሂሳብ',
    release: 'አሰራር',
    issue: 'ሂደት',
    createBd: 'BD ፍጠር',
    times: 'ጊዜ',
    authorizeCs: 'CS ፍቃድ ስጥ',
    giftTo: 'ለተጠቃሚ ስጠው',
    bdCreation: 'የቀረው የBD ፍጠር ገደብ',
    csAuthorization: 'የቀረው የCS ፍቃድ ኮታ',
    giftName: 'የስጦታ ስም',
    giftContents: 'የስጦታ ይዘት',
    check: 'አረጋግጥ',
    cancel: 'ይቅር',
    tip: 'ምክር',
    recipientsVip: 'የተቀባዩ የVIP ደረጃ ከስጦታ ጥቅል ገደብ በላይ ሆኗል። የዚህ ስጦታ የVIP ጥቅሞች ይጠፋሉ። እርግጠኛ ነህ መቀጠል ትፈልጋለህ?',
    confirm: 'አረጋግጥ',
    authorize: 'ፍቀድ',
    inviteBy: 'በተጠቃሚ መለያ ይጋብዙ',
    invite: 'ጋብዝ',
    inviteLink: 'የጋብዣ አገናኝ',
    copy: 'ገልብጥ',
    success: 'ስኬት',
    pleaseCheck: 'እባክዎ የተጠቃሚ መለያ ይመልከቱ',
    totalGift: 'የሁሉም አስተናጋጆች ጠቅላላ የስጦታ ገቢ (እንደ ደረጃ ማስተናገድ፣ ተግባር የመሳሰሉ የመድረክ ሽልማቶች አልተካተቱም)፣ የጉዳዩ አገልጋዮች የስጦታ ገቢ ያካትታል።',
    totalAgentsCom: 'ወኪሎች ከአስተናጋጆቻቸው ገቢ የሚያገኙት ጠቅላላ ኮሚሽን፣ የጉዳዩ አገልጋዮች ኮሚሽን ያካትታል።',
    allAgent: 'ሁሉም ወኪል',
    directAgent: 'ቀጥታ ወኪል',
    indirectAgent: 'በአግባቡ ወኪል',
    newUpgraded: 'አዲስ የደረጃ ከፍ ያለ ወኪል',
    newS: 'አዲስ ኤስ ወኪሎች',
    newB: 'አዲስ ቢ ወኪሎች',
    newC: 'አዲስ ሲ ወኪሎች',
    expectedReward: 'የሚጠበቀው ሽልማት',
    newA: 'አዲስ ኤ ወኪሎች',
    agencyLevel: 'የወኪል ደረጃ',
    nickname: 'ስምዋዋል',
    upgradeDate: 'የደረጃ ከፍ ያለበት ቀን',
    bdPolicy: 'የBD ፖሊሲ',
    agencyDetail: 'የወኪል ዝርዝር',
    agency: 'የወኪል አገልግሎት',
    hostCommission: 'የአስተናጋጅ ኮሚሽን',
    last6Days: 'ያለፉት 6 ቀናት',
    giftIncome: 'የስጦታ ገቢ',
    mins: 'ደቂቃ',
    agencyCenter: 'የወኪል ማዕከል',
    myIncome: 'የዛሬው ገቢ',
    totalHost: 'ጠቅላላ የአስተናጋጅ ነጥቦች',
    overview: 'አጠቃላይ እይታ',
    hostPoints: 'የአስተናጋጅ ነጥቦች',
    myHosts: 'የእኔ የአስተናጋጅ ነጥቦች',
    subagentHost: 'የጉዳዩ ወኪል የአስተናጋጅ ነጥቦች',
    subagencyNumber: 'የጉዳዩ አገልግሎት ቁጥር',
    otherIncome: 'ሌላ ገቢ',
    contactAdmin: 'አስተዳዳሪን ያነጋግሩ',
    whatsapp: 'ዋትስአፕ',
    bdCenter: 'የBD ማዕከል',
    copySuccess: 'ቅጂ ተሳክቷል',
    pleaseInput: 'እባክዎ የመሙላት መጠን ያስገቡ፣ ዝቅተኛ 10',
    agencyPolicy: 'የወኪል ፖሊሲ',
    agencyCommission: 'የወኪል ኮሚሽን',
    agencyCommission2: 'የወኪል ኮሚሽን = የኮሚሽን መጠን × የሁሉም አስተናጋጆች ጠቅላላ የስጦታ ገቢ (እንደ ደረጃ ማስተናገድ፣ ተግባር የመሳሰሉ የመድረክ ሽልማቶች አልተካተቱም)',
    excludingPlatform: '(እንደ ደረጃ ማስተናገድ፣ ተግባር የመሳሰሉ የመድረክ ሽልማቶች አልተካተቱም)',
    agencyCommissionCalculation: 'የወኪል ኮሚሽን ስሌት',
    level: 'ደረጃ',
    pointsTarget: 'የነጥቦች ግብ (ያለፉት 30 ቀናት)',
    points10000: '10,000 ነጥቦች = 1 የአሜሪካ ዶላር (M= ሚሊዮን)',
    note1: 'ማስታወሻ 1: ጠቅላላ ትክክለኛ ገቢ = የእርስዎ የወኪል አገልግሎት ገቢ + የእያንዳንዱ የጉዳዩ አገልጋዮች ደረጃ ገቢ',
    note2: 'ማስታወሻ 2: ወኪል ኮሚሽኖች አስተናጋጁ ስጦታ በReceivedቀ ጊዜ በተግባር ጊዜ ይመደባሉ።',
    note3: 'ማስታወሻ 3: ዝቅተኛው የገንዘብ መልስ መጠን 10 የአሜሪካ ዶላር ነው፣ እና የገንዘብ መልሶች በ10 ብዜት መሆን አለባቸው (ለምሳሌ: 10 USD, 20 USD, 30 USD)።',
    subagencycommission: 'የጉዳዩ አገልግሎት ኮሚሽን',
    theMain: 'ዋናው አገልግሎት ከእያንዳንዱ የጉዳዩ አገልጋዮች ደረጃ (T1, T2, T3, T4, ... Tn) ገቢ ኮሚሽን ሊያገኝ ይችላል፣ ከፍተኛው የኮሚሽን መጠን 16% ነው።',
    forExample: 'ለምሳሌ -',
    agencyA: 'Agency A አገልግሎት Agency B እና Agency C ን ጋብዟል።',
    agencyB: 'Agency B አገልግሎት Agency D እና Agency E ን ጋብዟል።',
    agencyC: 'Agency C አገልግሎት Agency F ን ጋብዟል።',
    noteFigures: '(ማስታወሻ: በቅንፍ ውስጥ ያሉት ቁጥሮች የእያንዳንዱን አገልግሎት አስተናጋጆች ገቢ ይወክላሉ)።',
    thusWe: 'ስለዚህ ከአገልግሎት A እስከ አገልግሎት F ያሉ አገልግሎቶች ጠቅላላ ትክክለኛ ገቢ እና የኮሚሽን መጠን ማስላት እንችላለን።',
    totalValid: 'ጠቅላላ ትክክለኛ ገቢ = የእርስዎ አገልግሎት ገቢ + የእያንዳንዱ የጉዳዩ አገልጋዮች ደረጃ ገቢ',
    aTotal: 'A ጠቅላላ ትክክለኛ ገቢ = A + B + C + D + E + F = 10M + 20M + 70M + 20M + 30M +80M = 230M (የኮሚሽን መጠን 20%)',
    bTotal: 'B ጠቅላላ ትክክለኛ ገቢ = B + D + E = 20M + 20M + 30M = 70M (የኮሚሽን መጠን 16%)',
    cTotal: 'C ጠቅላላ ትክክለኛ ገቢ = C + F = 70M + 80M =150M (የኮሚሽን መጠን 20%)',
    dTotal: 'D ጠቅላላ ትክክለኛ ገቢ =20M (የኮሚሽን መጠን 12%)',
    eTotal: 'E ጠቅላላ ትክክለኛ ገቢ =30M (የኮሚሽን መጠን 12%)',
    fTotal: 'F ጠቅላላ ትክክለኛ ገቢ =80M (የኮሚሽን መጠን 16%)',
    subagencyCommission: 'የጉዳዩ አገልግሎት ኮሚሽን = (የዋናው አገልግሎት የኮሚሽን መጠን - የጉዳዩ አገልግሎት የኮሚሽን መጠን) × የጉዳዩ አገልግሎት ጠቅላላ ትክክለኛ ገቢ',
    agencyAC: 'አገልግሎት {A} ከአገልግሎት {B} የሚያገኘው ኮሚሽን',
    thereforeAgency: 'ስለዚህ አገልግሎት {A} ከጉዳዩ አገልጋዮች የሚያገኘው ጠቅላላ ኮሚሽን',
    sinceAgency: 'አገልግሎት D፣ E እና F ጉዳዩ አገልጋዮች ስላላቸው የጉዳዩ አገልግሎት ኮሚሽን ማግኘት አይችሉም።',
    seniorPolicy: 'ከፍተኛ ፖሊሲ',
    nomore: 'ተጨማሪ ውሂብ የለም',
    active: 'ንቁ',
    disabled: 'ጠፍቷል',
    deleted: 'ተሰርዟል',
    lastLogintime: 'የመጨረሻ የመግባት ጊዜ',
    onmic: 'ዛሬ ማይክሮፎን ላይ'
  },
  sellerCoin: {
    detailsOf: 'የገንዘብ መልስ ዝርዝር',
    fundsSent: 'ገንዘብ ተልኳል',
    transfer: 'ማስተላለፍ',
    totalIncome: 'አጠቃላይ ገቢ',
    orderIncome: 'የትዕዛዝ ገቢ',
    estimatedReward: 'የሚጠበቀው ሽልማት',
    amount: 'መጠን',
    applicantId: 'የለማዊ መለያ',
    applicantName: 'የለማዊ ስም',
    orderId: 'የትዕዛዝ መታወቂያ',
    uploadScreenshot: 'ስክሪን ሾት ጫን',
    ensureWithdrawal: 'ገንዘብ መልስ እንደተሳካ ያረጋግጡ፣ ከዚያ የስክሪን ሽክርክሪት ይጫኑ እና ለለማዊው ለማሳወቅ ከታች ያለውን አዝራር ይጫኑ።',
    remain: 'ቀርቷል',
    pleasePay: 'ወዲያውኑ ይክፈሉ እና ደረሰኝ ይጫኑ። ጊዜ ከተሟላ ትዕዛዙ ለመክፈል የሚያስችለው ብቃት ይቅርናል።',
    youCan: 'በቀን እስከ 5,000 የግብዣ ነጥቦችን ማግኘት ትችላለህ',
    pleaseComplete: 'እባክዎ ገንዘብ መልስ በጊዜ ይጠናቀቁ ',
    unableTo: 'ክፍያ ማድረግ አልተቻለም፣ ውድቅ',
    notifyThe: 'ለማዊውን አሳውቅ',
    youCanGet: 'ትዕዛዞችን በጊዜ ከተካሄዱ 1%-3% ተጨማሪ ጉርሻ ማግኘት ይችላሉ።',
    ifYou: 'ትዕዛዞችን በ30 ደቂቃዎች ውስጥ ከተካሄዱ 3% ጉርሻ ማግኘት ይችላሉ።',
    egThe: 'ለምሳሌ፡ 90000 ነጥብ ዋጋ ያለው ትዕዛዝ፣ በ30 ደቂቃዎች ውስጥ ከተካሄዱበት 3% ጉርሻ ማግኘት ይችላሉ፣ ማለትም 90000 × 3% = 2700 ነጥቦች።',
    gotIt: 'ተገኘ',
    pleaseUpload: 'እባክዎ ምስል ይጫኑ',
    detail: 'ዝርዝር',
    balance: 'Balance',
    exchange: 'ለውጥ',
    all: 'ሁሉ',
    recharge: 'መሙላት',
    official: 'ኦፊሴላላዊ',
    exchangeDetail: 'የለውጥ ዝርዝር',
    coinSeller: 'ሳንቲም ሻጭ',
    levelUp: 'ደረጃ ማሳደግ',
    currentLevel: 'Current level',
    myBalance: 'የእኔ ቀሪ ሂሳብ',
    details: 'ዝርዝሮች',
    paymentMethod: 'የክፍያ መንገድ',
    myOrder: 'የእኔ ትዕዛዝ',
    paymentMenthod: 'የክፍያ መንገድ',
    acceptingOrders: 'ትዕዛዞች በመቀበል ላይ',
    unavailable: 'አይገኝም',
    greetingMessage: 'የሰላምታ መልእክት ማሰናከሪያ',
    serviceUnavailable: 'አገልግሎት አይገኝም',
    thisFeature: 'ይህ ባህሪ ጊዜያዊ ተቆልፏል። እባክዎ ለእገዛ የደንበኞች እገዛ ያግኙ።',
    editMessage: 'መልእክት አርትዕ',
    customizeYour: 'የሰላምታ መልእክትዎን እርስዎ ያብጁ። ስለ ሳንቲሞች መሙላት ጠቃሚ መረጃ ማካተት ይችላሉ።',
    theMessage: 'አዲስ ተጠቃሚ ከእርስዎ ጋር የግል ውይይት ሲጀምር መልእክቱ በራስ-ሰር ይላካል።',
    save: 'አስቀምጥ',
    pleaseEnterMessge: 'እባክዎ የሰላምታ መልእክትዎን ያስገቡ',
    salesMethod: 'የሽያጭ ዘዴ',
    user: 'ተጠቃሚ',
    coinseller: 'ሳንቲም ሻጭ',
    userId: 'የተጠቃሚ መታወቂያ',
    check: 'Check',
    coinAmount: 'የሳንቲም መጠን',
    pleaseEnter: 'እባክዎ 1 ብዜት ያስገቡ',
    enterAt: 'ቢያንስ 100 አስገባ፣ በ1 ብዜቶች',
    transferDetails: 'የማስተላለፊያ ዝርዝሮች',
    recommendSeller: 'ሻጩን ይመክሩ',
    recent30Day: 'ቅርብ 30-ቀን የሳንቲም ሽያጭ',
    whatsapp: 'WhatsApp',
    chat: 'ውይይት',
    yourCountry: 'አሁን በአገርዎ ውስጥ ሳንቲም ሻጮች የሉም።',
    pleaseContact: 'እባክዎ የደንበኞች እገዛ ያግኙ።',
    customerSupport: 'የደንበኞች እገዛ',
    contact: 'አግኝ',
    customRecharge: 'ራስ-ሰር መሙላት',
    rechargeDetails: 'የመሙላት ዝርዝሮች',
    myPoints: 'የእኔ ነጥቦች',
    todayRemaining: 'የዛሬ የቀረ ኮታ',
    customExchange: 'ራስ-ሰር ለውጥ',
    exchangeDetails: 'የለውጥ ዝርዝሮች',
    rechargeRules: 'የመሙላት ህጎች',
    sellerLevel: 'የሻጭ ደረጃ',
    proportion: 'ሬሾ',
    levelRequirement: 'የደረጃ መስፈርት',
    beginner: 'ጀማሪ',
    singleRecharge: 'ነጠላ መሙላት',
    standard: 'መስፈርት',
    senior: 'ከፍተኛ',
    exchangeRules: 'የለውጥ ህጎች',
    note: 'Note',
    seniorCoin: 'ከፍተኛ ሳንቲም ሻጭ {point} ነጥቦችን በነፃ ያገኛል በየቀኑ። ተጨማሪ በ ',
    beginnerSeller: 'ጀማሪ ሻጭ',
    standardSeller: 'መስፈርት ሻጭ',
    seniorSeller: 'ከፍተኛ ሻጭ',
    cancel: 'Cancel',
    pleaseInput: 'Please input the recharge amount, minimum 10',
    pleaseInput2: 'እባክዎ የመሙላት መጠን ያስገቡ፣ ብዜቶች 100K',
    confirmation: 'ማረጋገጫ',
    userName: 'የተጠቃሚ ስም',
    theUser: 'ተጠቃሚው በጥቁር ዝርዝር ላይ ተደርጎታል',
    enterAmount: 'መጠን ያስገቡ',
    pleaseInput3: 'እባክዎ መጠን ያስገቡ',
    theAmount: 'መጠኑ የ100000 ብዜት መሆን አለበት',
    pleaseInput4: 'እባክዎ መጠን ያስገቡ ወይም ይምረጡ',
    pleaseSelect: 'እባክዎ የሽያጭ ዘዴ ይምረጡ',
    pleaseInput5: 'እባክዎ userId ያስገቡ',
    atLeast: 'ቢያንስ 100K ሳንቲሞች ለማስተላለፍ~',
    pleaseSelect2: 'እባክዎ የክፍያ መንገድ ይምረጡ',
    minimum: 'ዝቅተኛ',
    theAmount3: 'መጠኑ የ1 ብዜት መሆን አለበት',
    lessThan: 'ከ100000 ያነሰ ወይም እኩል',
    orders: 'ትዕዛዞች',
    applicant: 'ለማመልከቻ',
    method: 'ዘዴ',
    withdrawTime: 'የመልቀቂያ ጊዜ',
    viewDetail: 'ዝርዝር ይመልከቱ',
    toBe: 'ለማረጋገጥ ይቀራል',
    toBePaid: 'ለመክፈል ይቀራል',
    toBeCompleted: 'ለማጠናቀቅ ይቀራል',
    completed: 'ተጠናቅቋል',
    abnormal: 'ያልተለመደ',
    refused: 'Refused',
    confirmationTimeout: 'የማረጋገጫ ጊዜ አልፏል',
    paymentTimeout: 'የክፍያ ጊዜ አልፏል',
    binance: 'ቢናንስ',
    scanThe: 'ለመክፈል QR ኮድ ይቃኙ',
    quantity: 'ብዛት',
    orderAmount: 'የትዕዛዝ መጠን',
    date: 'ቀን',
    payNow: 'አሁን ይክፈሉ',
    payment: 'ክፍያ',
    pleasePay2: 'እባክዎ በሚከተለው መንገድ ይክፈሉ',
    chainName: 'የሰንሰለት ስም',
    contractAddress: 'የኮንትራትት አድራሻ',
    theAbove: 'ከላይ ያለው አድራሻ ለዚህ መሙላት ብቻ የሚሰራ ነው።',
    copy: 'Copy',
    notice: 'ማስታወቂያ',
    pleaseTransfer: 'የቢናንስ ክፍያ ለመሸፈን እባክዎ ተጨማሪ 1 USDT ያስተላልፉ። ይህንን ማድረግ ካላደረጉ የሳንቲምዎ መሙላት ሊቆይ ይችላል።',
    paymentsMust: 'ክፍያዎች በ0.5 ሰዓት ውስጥ መጠናቀቅ አለባቸው, አለበለዚያ መድረኩ ለማንኛውም ጉዳይ ኃላፊነት አይወስድም።',
    add: 'ጨምር',
    confirmTo: 'ይህንን የክፍያ ዘዴ ለማስወገድ ያረጋግጡ',
    countryCurrency: 'ሀገር እና ምንዛሪ አይነት',
    selectPayment: 'ሊልኩት የሚችሉትን የክፍያ ዘዴ ይምረጡ',
    coinsSeller: 'የሳንቲም ሻጭ ህጎች',
    standrd: 'መስፈርት',
    salesMethods: 'የሽያጭ ዘዴዎች',
    coinsellerRules: 'የሳንቲም ሻጭ ህጎች',
    whenApplying: 'የሳንቲም ሻጭ ሁኔታ ለማሻሻል ሲጠየቁ፣ የተቀማጭ ገንዘብ መስፈርቶች የሉም፣ የሳንቲም ሻጭ ደረጃ ለማሻሻል 1-ጊዜ መሙላት ብቻ ያስፈልጋል። እንደ ሳንቲም ሻጭ ከቦታዎ ለመልቀቅ ከመረጡ፣ የአሁኑ የሳንቲም ሻጭ ሚና ያልተቋረጠ ይሆናል።',
    youCanReplenish: 'ሂሳብዎን በUSDT፣ Epay በቀጥታ ወይም በሌላ ሳንቲም ሻጭ ሊሞሉት ይችላሉ።',
    fraudulentActivities: 'በHala መድረክ ውስጥ ሀቀኛ እንቅስቃሴዎች በጥብቅ የተከለከሉ ናቸው።',
    anyViolations: 'ማንኛውም ማፈራረሻ የሳንቲም ሻጩን ሂሳብ ማቋረጥ ያስከትላል።',
    allRights: 'ሁሉም መብቶች በHala የተጠበቁ ናቸው።',
    transferDetail: 'የማስተላለፊያ ዝርዝር'
  },
  centerHost: {
    baseSalary: 'Base Salary',
    invitation: 'ግብዣ',
    tasks: 'ተግባራት',
    other: 'ሌሎች',
    consume: 'መጠቀም',
    giftIncome: 'Gift Income',
    received: 'ተቀብሏል',
    from: 'ከ',
    luckyGift: 'እድለኛ ስጦታ',
    hostCenter: 'የአስተናጋጅ ማዕከል',
    noAgent: 'ምንም ወኪል የለም',
    last7: 'ያለፈው 7 ቀናት',
    hourlyIncome: 'በሰዓት ገቢ',
    toReach: 'to reach',
    rules: 'ህጎች',
    pointsOverview: 'የነጥቦች አጠቃላይ እይታ',
    totalIncome: 'Total Income',
    gifts: 'ስጦታዎች',
    workDetail: 'የሥራ ዝርዝር',
    liveDuration: 'Live Duration',
    mins: 'mins',
    todaysLive: 'የዛሬ ቀጥታ መዝገብ',
    dailyStatistics: 'ዕለታዊ ስታቲስቲክስ',
    startTime: 'የመጀመሪያ ጊዜ',
    endTime: 'የመጨረሻ ጊዜ',
    duration: 'ርዝመት',
    points: 'ነጥቦች',
    date: 'Date',
    giftPoints: 'የስጦታ ነጥቦች',
    removeBinding: 'መያዣ ያስወግዱ',
    thisAction2: 'ይህ እርምጃ ከ {agentName} ያልተገናኙት ይሆናል። ከማላገጃው ጋር ለመቀጠል ከፈለጉ እባክዎ ያረጋግጡ'
  },
  bombRule: {
    afterThe: 'በክፍሉ ውስጥ ያለው የፍንዳታ ዋጋ የተወሰነ መጠን ከደረሰ በኋላ፣ የስጦታ ቦምብ በክፍሉ ውስጥ ይታያል።',
    oneCoins: 'በክፍሉ ውስጥ የተቀበሉ 1 ሳንቲሞች = 1 የፍንዳታ ዋጋ',
    itWill: 'መስፈርቶችን ከተሟላ በኋላ በራስ-ሰር ይፈነዳል፣ እና የክፍሉ ባለቤት ተጓዳኝ የወርቅ ሳንቲም ሽልማቶችን ይቀበላል።'
  },
  descriptionLevel: {
    wealth: 'ሀብት',
    charm: 'ጨዋታ',
    wealthValue: 'የሀብት ዋጋ',
    charmValue: 'የጨዋታ ዋጋ',
    needTo: 'ያስፈልጋል',
    send: 'ላክ',
    receive: 'ተቀበል',
    forThe: 'ለማሻሻል',
    theRich: 'የባለ ጠጋ ደረጃ በገንዘብ የገነዘቡ ሳንቲሞች ይቆጠራል',
    theCharm: 'የጨዋታ ደረጃ በሚቀበሉት ሳንቲሞች ብዛት ላይ የተመሰረተ ነው',
    LevelLabel: 'የደረጃ መለያ',
    level: 'Level',
    levelLogo: 'የደረጃ ሎጎ'
  },
  gameRank: {
    gameRank: 'የጨዋታ ደረጃ',
    rules: 'Rules',
    thisWeek: 'ይህ ሳምንት',
    lastWeek: 'ያለፈው ሳምንት',
    agentGaming: 'የአግንት ጨዋታ ገቢ ደረጃ',
    rankingRewards: 'ደረጃ ሽልማቶች',
    rankingIs: 'ደረጃው በአግንት ክፍል እና በንዑስ ክፍሎቹ ውስጥ ያሉት ተጠቃሚዎች አጠቃላይ ውርርድ ማሽከርከር ላይ የተመሰረተ ነው።',
    hostRoom: 'የአስተናጋጅ ክፍል ገቢ ደረጃ',
    rankingIs2: 'ደረጃው በአስተናጋጁ ክፍል ውስጥ በተፈጠረው አጠቃላይ የጨዋታ ገቢ ላይ የተመሰረተ ነው።',
    notes: 'ማስታወሻዎች',
    eventDuration: 'የዝግጅት ርዝመት- እያንዳንዱ የቀን መቁጠሪያ ሳምንት። ሽልማቶች የሚከፈሉት ከሆነ ብቻ ነው።',
    rewardsAre: 'Rewards are distributed only if the corresponding revenue requirements are met.',
    allRewards: 'All rewards will be issued within 1-2 working days after the event ends.',
    halaReserves: 'Hala የዚህን ክስተት የመጨረሻ ትርጉም መብት ይጠብቃል።',
    rewardsDetail: 'የሽልማት ዝርዝር',
    decorationsPreview: 'የዲኮሬሽን ቅድመ እይታ'
  },
  gameLegacyHall: {
    surpriseLucky: 'አስደናቂ እድለኛ ቦርሳ',
    dailyPlayers: 'ዕለታዊ ተጫዋቾች በቀጣዩ ቀን የዘፈቀደ ሳንቲሞች ለማግኘት እድለኛ ቦርሳ መክፈት ይችላሉ።',
    eventRule: 'የክስተት ህግ',
    usersSpending: 'ተጠቃሚዎች በክስተት ጨዋታዎች ውስጥ ያለው ወጪ ለደረጃ ነጥባቸው ይቆጠራል።',
    thePlatform: 'መድረኩ በየ 4 ሰዓቱ የክስተት ጨዋታዎችን ይሽከረከራል፣ በእያንዳንዱ ሽክርክሪት 4 የተለያዩ ጨዋታዎች ይገኙበታል።',
    theTop: 'ከፍተኛዎቹ 3 ዕለታዊ ተጫዋቾች ፍሬሞችን እና የሳንቲም ሽልማቶችን ይቀበላሉ።',
    theTop2: 'ከፍተኛዎቹ 10 ሳምንታዊ ተጫዋቾች ፍሬሞችን እና የሳንቲም ሽልማቶችን ይቀበላሉ።',
    usersWho: 'በየቀኑ በክስተት ጨዋታዎች የሚሳተፉ ተጠቃሚዎች የዘፈቀደ መጠን ያላቸውን ሳንቲሞች ለማግኘት በቀጣዩ ቀን እድለኛ ቦርሳ መክፈት ይችላሉ። በክስተት ጨዋታዎች ውስጥ የበለጠ ብትወጡ የበለጠ ሳንቲሞች ማግኘት ትችላለህ።',
    behindPrevious: 'ከቀዳሚው በስተጀርባ',
    thisWeek: 'This Week',
    lastWeek: 'Last Week',
    countdown: 'ቆጠራ፡',
    days: 'ቀናት',
    winOver: 'ከ ... በላይ ያሸንፉ',
    coinsfrom: 'በአንድ ቀን ውስጥ ከጨዋታዎች ሳንቲሞች',
    earnOver: 'ከ ... በላይ ያግኙ',
    coinsWitdh: 'የመመለሻ ተመን እስከ',
    fromOneDay: 'ከአንድ ቀን በ',
    game: 'ጨዋታ',
    fromA: 'ከአንድ ነጠላ ቦታ በ',
    inthisWeek: 'በዚህ ሳምንት',
    earnUp: 'እስከ ድረስ ያግኙ',
    inAsingle: 'በአንድ ቀን ውስጥ',
    eventRules: 'የክስተት ህጎች',
    participateIn: 'ትልቅ እድለኛ ቦርሳ ለመጠየቅ ነገ በጨዋታው ውስጥ ይሳተፉ',
    youDid: 'የሳንቲም ሽልማቱን አላገኙም። በጨዋታው ውስጥ ይሳተፉ እና ነገ እድለኛ ቦርሳውን ለማግኘት መቀጠል ይችላሉ።',
    participateIn2: 'በጨዋታው ውስጥ ይሳተፉ እና ነገ እድለኛ ቦርሳውን ለማግኘት መቀጠል ይችላሉ።',
    topDaily: 'ከፍተኛ ዕለታዊ ሳንቲም አሸናፊ',
    topPayout: 'ከፍተኛ የክፍያ መጠን አሸናፊ',
    topCoins: 'ከፍተኛ ሳንቲም አሸናፊ በአንድ ሳጥን ሳምንታዊ',
    topPayout2: 'ከፍተኛ የክፍያ መጠን አሸናፊ በአንድ ሳጥን ሳምንታዊ',
    topWeekly: 'ከፍተኛ ሳምንታዊ ሳንቲም አሸናፊ',
    historicalTop: 'ታሪካዊ ከፍተኛ ሳንቲም አሸናፊ በአንድ ቀን',
    historicalTop2: 'ታሪካዊ ከፍተኛ የክፍያ መጠን አሸናፊ በአንድ ቀን',
    historicalTop3: 'ታሪካዊ ከፍተኛ ሳንቲም አሸናፊ በአንድ ሳጥን',
    historicalTop4: 'ታሪካዊ ከፍተኛ የክፍያ መጠን አሸናፊ በአንድ ሳጥን',
    historicalTop5: 'ታሪካዊ ከፍተኛ ሳንቲም አሸናፊ በአንድ ሳምንት',
    gameReward: 'የጨዋታ ሽልማት',
    usersSpending2: 'ተጠቃሚዎች በክስተት ጨዋታዎች ውስጥ ያለው ወጪ ለደረጃ ነጥባቸው ይቆጠራል።',
    theTop3: 'ከፍተኛዎቹ 3 ዕለታዊ ተጫዋቾች ፍሬሞችን እና የሳንቲም ሽልማቶችን ይቀበላሉ።',
    theTop4: 'ከፍተኛዎቹ 10 ሳምንታዊ ተጫዋቾች ፍሬሞችን እና የሳንቲም ሽልማቶችን ይቀበላሉ።',
    usersWho2: 'በየቀኑ በክስተት ጨዋታዎች የሚሳተፉ ተጠቃሚዎች የዘፈቀደ መጠን ያላቸውን ሳንቲሞች ለማግኘት በቀጣዩ ቀን እድለኛ ቦርሳ መክፈት ይችላሉ። በክስተት ጨዋታዎች ውስጥ የበለጠ ብትወጡ የበለጠ ሳንቲሞች ማግኘት ትችላለህ።',
    coins: 'ሳንቲሞች',
    flameRider: 'እሳት ተሳፋሪ',
    sportCar: 'ስፖርት መኪና',
    captainMeow: 'ካፕቴን ምው',
    profileFrame: 'የመገለጫ ፍሬም'
  },
  gold: {
    coinsDetail: 'የሳንቲሞች ዝርዝር',
    coinBalance: 'የሳንቲም ሚዛን',
    all: 'ALL',
    sendGifts: 'ስጦታዎች ይላኩ',
    purchaseItems: 'ዕቃዎች ይግዙ',
    games: 'ጨዋታዎች',
    exchange: 'Exchange',
    recharge: 'Recharge',
    activeReword: 'የእንቅስቃሴ ሽልማቶች',
  },
  integral: {
    all: 'All',
    cashOut: 'ገንዘብ ማውጣት',
    transfer: 'Transfer',
    orderId: 'Order ID',
    paymentMenthod: 'Payment Menthod',
    withdrawalTime: 'የመልቀቂያ ጊዜ',
    pointsAmount: 'የነጥቦች መጠን',
    depositAmount: 'የተቀማጭ መጠን',
    coinsAmount: 'የሳንቲሞች መጠን',
    transferTo: 'ወደ ማስተላለፍ',
    normal: 'መደበኛ',
    pending: 'በመጠባበቅ ላይ',
    success: 'Success',
    failed: 'አልተሳካም',
    points: 'Points',
    pointsBalance: 'የነጥቦች ሚዛን',
    frozenPoints: 'የታጠዩ ነጥቦች',
    details: 'Details',
    exchange: 'Exchange',
    currencyType: 'የምንዛሪ አይነት',
    paymentMethod: 'Payment method',
    pointsAmount2: 'ገንዘብ ለማውጣት የነጥቦች መጠን',
    enterA: '100,000 ብዜት ያስገቡ (ዝቅተኛ 200,000)',
    enterA2: '100000 ብዜት ያስገቡ',
    accountInformation: 'የሂሳብ መረጃ',
    withdraw: 'ማውጣት',
    amount: 'Amount',
    exchangeRate: 'የምንዛሪ መለኪያ',
    exchangePoints: 'የለውጥ ነጥቦች',
    enterUserId: 'የተጠቃሚ መታወቂያ ያስገቡ',
    check: 'Check',
    fee: 'ክፍያ',
    theAgency: 'ኤጀንሲው ይቀበላል',
    transferFee: 'የማስተላለፊያ ክፍያ- 2%። ዝቅተኛ ማስተላለፊያ ≥ 100,000 ነጥቦች።',
    clickTransfer: 'ተጓዳኝ ነጥቦችን ለአግንቶችዎ ለማስተላለፍ የማስተላለፊያ ቁልፍን ጠቅ ያድርጉ',
    afterThe2: 'ማስተላለፊያው ከተጠናቀቀ በኋላ ሊሰርድ ወይም ሊመለስ አይችልም።',
    transferPoints: 'ነጥቦች ማስተላለፍ',
    recommendedMethod: 'የሚመከር ዘዴ',
    lowerFees: 'ዝቅተኛ ክፍያዎች እና በ24 ሰዓታት ውስጥ ይገምገማል',
    paymentPassword: 'የክፍያ የይለፍ ቃል አልተገነባም',
    cashOut2: 'ገንዘብ ማውጣት እና ልውውጦች የክፍያ የይለፍ ቃል ማረጋገጫ ያስፈልጋሉ። እባክዎ በመጀመሪያ የክፍያ የይለፍ ቃልዎን ያዘጋጁ።',
    cancel: 'Cancel',
    goTo: 'ወደ ቅንብሮች ይሂዱ',
    youHave: '5 ያልተሳኩ ሙከራዎችን አድርሰዋል። አንድ ተጨማሪ ያልተሳካ ሙከራ መለያዎን እንዲበስል ያደርገዋል። የይለፍ ቃልዎን ከረሱ፣ እባክዎን ዳግም ያስጀምሩት።',
    inputIncorrect: 'ብዙ ጊዜ የተሳሳተ የይለፍ ቃል አስገባ። ሂሳብዎ ተቀዝቍዟል፣ እባክዎ በኋላ እንደገና ይሞክሩ',
    verify: 'አረጋግጥ',
    gotIt: 'Got it',
    pointsInfo: 'የነጥቦች መረጃ',
    whenA: 'ተጠቃሚ በGoogle በኩል የተሞሉ ሳንቲሞችን በመጠቀም ስጦታዎችን ሲልክሎት፣ የሚቀበሉት ነጥቦች ከመገኘት በፊት ለ7 ቀናት ይቀዘቅዛሉ። ተጠቃሚ ገንዘብ መመለስ ከጠየቀ፣ እነዚያ ነጥቦች ይቀንሳሉ። እባክዎ የመድረክ ህጎችን ይከተሉ እና ማንኛውንም ማፈራረሻ ያስወግዱ።',
    frozenPointsAre: 'የታጠዩ ነጥቦች በጠቅላላ የነጥቦች ሚዛን ውስጥ ይገኙበታል',
    theUser2: 'ተጠቃሚው በጥቁር ዝርዝር ላይ ተደርጎታል',
    successfulWithdrawal: 'ስኬታማ መልቀቂያ',
    withdrawalAmount: 'የመልቀቂያ መጠን',
    theFunds: 'ገንዘቡ በ24 ሰዓታት ውስጥ ይደርሳል',
    pleaseEnter2: 'እባክዎ የይለፍ ቃል ያስገቡ',
    passwordIncorrect: 'የይለፍ ቃል የተሳሳተ ነው',
    theAmount4: 'መጠኑ የ100000 ብዜት መሆን አለበት',
    pleaseEnter3: 'እባክዎ የተጠቃሚ መታወቂያ ያስገቡ',
    pleaseEnter4: 'እባክዎ ትክክለኛውን የተጠቃሚ መታወቂያ ያስገቡ',
    pleaseEnter5: 'እባክዎ መጠን ያስገቡ',
    minimumTransfer: 'ዝቅተኛ ማስተላለፊያ ≥ 100,000 ነጥቦች',
    pleaseSelect3: 'እባክዎ ዘዴውን ይምረጡ',
    minimum: 'minimum',
    theAmount5: 'መጠኑ ከዚህ ያነሰ መሆን አለበት',
    illegalInput: 'ሕገወጥ ግብዓት',
    pleaseEnter6: 'እባክዎ የሂሳብ መረጃ ያስገቡ'
  },
  invite: {
    inviteGame: 'የጨዋታ ተጠቃሚ ይጋብዙ',
    currentRebate: 'የአሁን ሬቴት',
    need: 'ያስፈልጋል',
    toProgress: 'ወደ ቀጣዩ ደረጃ ለመቀጠል',
    gameReward: 'Game Reward',
    referralData: 'የማጣቀሻ ዳታ',
    referralList: 'የማጣቀሻ ዝርዝር',
    date: 'Date',
    gameBets: 'የጨዋታ ውርርድ',
    inviteRewards: 'የግብዣ ሽልማቶች',
    viewMore: 'ተጨማሪ ይመልከቱ',
    inviteFriends: 'ወዳጆች ይጋብዙ',
    myReward: 'የእኔ ሽልማት',
    totalRewards: 'አጠቃላይ ሽልማቶች',
    dailyReward: 'ዕለታዊ ሽልማት',
    inviteRules: 'የግብዣ ህጎች',
    yourRebate: 'የእርስዎ ሬቴት መጠን ባለፉት 30 ቀናት አጠቃላይ ትክክለኛ ውርርዶችዎ ላይ የተመሰረተ ነው።',
    totalValid2: 'አጠቃላይ ትክክለኛ ውርርዶች = የራስዎ ውርርዶች + የተጋቡት ተጠቃሚዎች የእያንዳንዱ ደረጃ የራሳቸው ውርርዶች',
    rebateFrom: 'ሬቴት ከ Tier-1 የተጋቡ ተጠቃሚዎች = የራሳቸው ውርርዶች × የእርስዎ ሬቴት መጠን',
    rebateFrom2: 'ሬቴት ከ Tier-2 የተጋቡ ተጠቃሚዎች = የራሳቸው ውርርዶች × (የእርስዎ ሬቴት መጠን - Tier-1 ሬቴት መጠን)',
    ifThe: 'Tier-2 የተጋቡ ተጠቃሚ Tier-3 ተጠቃሚ ከጋብዘ አጠቃላይ ትክክለኛ ውርርዶቹን ሊጨምር ይችላል፣ ነገር ግን ከTier-3 ሬቴት ማግኘት አይችልም።',
    example: 'ምሳሌ',
    tier1: 'Tier-1 የተጋቡ - በቀጥታ የተጋቡትን ሬቴት እንዴት ማስላት እንደሚቻል?',
    asRebate: 'ከ B, C እና D የ A ሬቴት = (የ B ነጠላ ውርርዶች + የ C ነጠላ ውርርዶች + የ D ነጠላ ውርርዶች) × የ A ሬቴት መጠን =',
    bsRebate: 'ከ E እና F የ B ሬቴት = (የ E ነጠላ ውርርዶች + የ F ነጠላ ውርርዶች) × የ B ሬቴት መጠን =',
    csRebate: 'ከ G የ C ሬቴት = የ G ነጠላ ውርርዶች × የ C ሬቴት መጠን =',
    tier2: 'Tier-2 የተጋቡ - በተዘዋዋሪ የተጋቡትን ሬቴት እንዴት ማስላት እንደሚቻል?',
    asRebate2: 'ከ E እና F የ A ሬቴት = (የ A ሬቴት መጠን - የ B ሬቴት መጠን) × (የ E ነጠላ ውርርዶች + የ F ነጠላ ውርርዶች) =',
    asRebate3: 'ከ G የ A ሬቴት = (የ A ሬቴት መጠን - የ C ሬቴት መጠን) × የ G ነጠላ ውርርዶች =',
    myInvitation: 'የእኔ ግብዣ',
    search: 'Search',
    invitationTime: 'የግብዣ ጊዜ',
    inviteHost: 'Invite Host',
    inviteA: 'አስተናጋጅ ይጋብዙ፣ እያንዳንዳቸው እስከ',
    todayRewards: 'የዛሬ ሽልማቶች',
    rewardDetail: 'የሽልማት ዝርዝር',
    creatorRewards: 'የፈጣሪ ሽልማት የዋሌት',
    collect: 'አሰባስብ',
    invitationDate: 'የግብዣ ቀን',
    hostPolicy: 'የአስተናጋጅ ፖሊሲ',
    halaReserves2: 'Hala ከላይ ያሉትን ፖሊሲዎች የመጨረሻ ትርጉም መብት ይጠብቃል።'
  },
  listContribution: {
    contributiont: 'አስተዋፅዖ',
    host: 'Host',
    wealth: 'Wealth',
    today: 'Today',
    yesterday: 'ትላንትན',
    game: 'Game',
    gift: 'ስጦታ',
    hostEarnings: 'የአስተናጋጅ ገቢ'
  },
  missionRule: {
    hostPolicy: 'Host Policy',
    halaReserves3: 'Hala ከላይ ያሉትን ፖሊሲዎች የመጨረሻ ትርጉም መብት ይጠብቃል።'
  },
  purchase: {
    recharge: 'Recharge',
    userId: 'User ID',
    confirm: 'Confirm',
    switchAccount: 'ሂሳብ ቀይር',
    countryRegion: 'ሀገር/ክልል',
    officialAgency: 'ኦፊሴላላዊ ኤጀንሲ መሙላት',
    ttOff: '20% ቅናሽ',
    totalAmount: 'አጠቃላይ መጠን',
    purchase: 'ግዢ',
    pleaseComfirm: 'እባክዎ የተጠቃሚ መታወቂያ ያረጋግጡ',
    pleaseInput8: 'እባክዎ የተጠቃሚ መታወቂያ ያስገቡ',
    onlineService: 'የመስመር ላይ አገልግሎት',
    dealOf: 'ያለፈው 30 ቀናት ውርይት',
    recent30Day2: 'ቅርብ 30-ቀን የሳንቲም ሽያጭ',
    paymentMethod: 'Payment Method',
    whatsapp: 'WhatsApp',
    chat: 'Chat',
    yourCountry2: 'አሁን በአገርዎ ውስጥ ሳንቲም ሻጮች የሉም።',
    pleaseContact2: 'እባክዎ የደንበኞች እገዛ ያግኙ።',
    customerSupport: 'customer support',
    contact: 'Contact'
  },
  roomGiftRule: {
    eventRules: 'Event Rules',
    treasureChest: 'የገንዘብ ሳጥን እድገት በክፍሉ ውስጥ ስጦታዎች በመስጠት ይጨምራል',
    whenThe: 'የሳጥኑ ቁልፍ የእድገት አሞሌ ሲሞላ የገንዘብ ሳጥኑ ይከፈታል',
    afterThe3: '.ደረጃ 3 እና ደረጃ 4 የገንዘብ ሳጥኖች መስፈርቶችን ከተሟሉ በኋላ ለ1 ደቂቃ ይቆለፋሉ ከዚያም በራስ-ሰር ይከፈታሉ።',
    everyoneIn: 'በክፍሉ ውስጥ ያሉ ሁሉም ሰዎች በገንዘብ ሣጥን ውስጥ ሽልማቶችን የማግኘት ዕድል አላቸው።',
    onceThe: 'አንዴ ውድ ሣጥኑ ከተከፈተ በኋላ ስርዓቱ ሽልማቱን ወደ መለያዎ እስኪሰጥ ድረስ ብዙ ደቂቃዎችን ሊወስድ ይችላል። የወርቅ ሳንቲሞቹ ወደ ቀሪ ሒሳብዎ ይታከላሉ እና ልብሱ ወደ ክምችትዎ ይታከላል።',
    theHigher: 'የግምጃ ቤቱ ደረጃ ከፍ ባለ መጠን በውስጡ ያሉት ሽልማቶች የበለጠ ይሆናሉ',
    ifYou2: 'አሁን ካለህበት ዝቅተኛ የቪአይፒ ደረጃ ጋር እንደ ቪአይፒ ከተመረጥክ የቪአይፒ ደረጃው ተግባራዊ አይሆንም',
    theProgress: 'የደረት ቁልፍ የሂደት አሞሌ በየቀኑ 00:00 (UTC+5:30) ዳግም ይጀምራል'
  },
  share: {
    joinHala: 'ብዙ የገቢ ዕድሎችን ለመክፈት እና ለኤጀንሲዎች ብጁ ጥቅማጥቅሞችን እና ሽልማቶችን ለመደሰት Halaን ይቀላቀሉ።',
    downloadTo: 'አጋር ለመሆን ያውርዱ',
    joinHala2: 'ለአዝናኝ ጨዋታዎች እና አስደናቂ ሽልማቶችን የማግኘት እድል ለማግኘት Halaን ይቀላቀሉ።',
    downloadAnd: 'ያውርዱ እና ማሸነፍ ይጀምሩ',
    joinHala3: 'Halaን ይቀላቀሉ እና የማስተናገጃ ጉዞዎን ይጀምሩ። ዕለታዊ ጉርሻዎችን እስከ $36 ያግኙ!',
    inviteYou: 'ኤጀንሲን እንድትቀላቀሉ ይጋብዙዎታል',
    downloadNow: 'ማስተናገድ ለመጀመር አሁን ያውርዱ',
    comeWith: 'በሃላ ቻት ሩም ለመቀላቀል ከእኔ ጋር ይምጡ',
    enthusiastsFrom: 'በዓለም ዙሪያ ያሉ አድናቂዎች ለመጋራት ይሰበሰባሉ።',
    igniteEndless: 'ማለቂያ የሌለው መዝናኛን ያብሩ',
    download: 'አውርድ',
    halaLive: 'Hala Live',
    showMe: 'በአለም ደስተኛ ሆኜ አሳየኝ።',
    saySomething: 'የሆነ ነገር በል...',
    downloadHala: 'Hala መተግበሪያን ያውርዱ'
  },
  starHost: {
    starHost: 'የኮከብ አስተናጋጅ',
    level2: 'ደረጃ {level} ለ {days} ቀናት ተጠብቆ ቆይቷል',
    currentSalary: 'የአሁኑ ደመወዝ',
    points: 'Points',
    likes: 'መውደዶች',
    stillNeed: 'Still need',
    done: 'ተከናውኗል',
    numberOf2: 'የስጦታዎች ብዛት',
    gifters: 'ስጦታዎች',
    gcoinGifts: 'የ Gcoin ስጦታዎች',
    gifts: 'gifts',
    liveDuration: 'Live Duration',
    min: 'ደቂቃ',
    completeAll: 'ለማሻሻል ሁሉንም የሚከተሉትን ተግባራት ያጠናቅቁ',
    follower: 'ተከታይ',
    numberOf3: 'የስጦታዎች ብዛት',
    daysAt: 'ቀናት በ {level} ደረጃ',
    giftCollection: 'የስጦታ ስብስብ',
    gift: 'Gift',
    date: 'Date',
    expectedSalary: 'የሚጠበቀው ደመወዝ',
    gcoin: 'Gcoin',
    status: 'ሁኔታ',
    levelReached: ' ደረጃ ደርሷል',
    notAchieved: 'አልተሳካም።',
    starHost2: 'የኮከብ አስተናጋጅ ደንቦች',
    eachStar: 'እያንዳንዱ የኮከብ አስተናጋጅ የ3-ቀን የሙከራ ጊዜ አለው።',
    theyWill: 'ኦፊሴላዊ የኮከብ አስተናጋጅ የሚሆኑት ለ3ቱ ቀናት የA-ደረጃ መስፈርቶችን ካሟሉ ብቻ ነው።',
    thoseWho: 'እለታዊውን የA-ደረጃ ኢላማዎች ማሟላት ያልቻሉ ይባረራሉ',
    firedHosts: 'የተባረሩ አስተናጋጆች የስታር አስተናጋጅ ቤዝ ደመወዝ ማግኘት አይችሉም',
    starHost3: 'የኮከብ አስተናጋጅ መነሻ ደመወዝ በየሳምንቱ በየሰኞ ይከፈላል',
    ifA: 'አንድ የኮከብ አስተናጋጅ ዕለታዊ ተግባራቱን ካላጠናቀቀ፣ የሰዓት ደሞዙን 50% ብቻ ይቀበላሉ።',
    selfGifting: 'ለሁሉም የስጦታ ኢላማዎች እራስን መስጠት በጥብቅ የተከለከለ ነው።',
    starHost4: 'የተለያየ ደረጃ ያላቸው የኮከብ አስተናጋጅ ሽልማቶች',
    level: 'Level',
    dailyExtra: 'ዕለታዊ ተጨማሪ ነጥቦች ሽልማቶች',
    liveBroadcast: 'የቀጥታ ስርጭት ጊዜ ያስፈልጋል',
    starHost5: 'ለተለያዩ ደረጃዎች የኮከብ አስተናጋጅ መስፈርቶች',
    requirements: 'መስፈርቶች(ቶች)',
    yourApplication: 'ማመልከቻዎ በይፋ ጸድቋል',
    stayOn: 'ለ 7 ቀናት በ A-ደረጃ ላይ ይቆዩ',
    over1k: 'ከ1ሺ በላይ ደጋፊዎች',
    totalGifter: 'ጠቅላላ የስጦታ ሰጪ ቁጥር > 300',
    receiveAll: 'ሁሉንም "ዕድለኛ" ስጦታዎች ተቀበል',
    everyLucky: 'እያንዳንዱ እድለኛ የስጦታ ቁጥር ከ100 በላይ መሆን አለበት።',
    stayOn2: 'በS-Level ለ10 ቀናት ይቆዩ',
    over2k: 'ከ2ሺ በላይ ደጋፊዎች',
    totalGifter2: 'ጠቅላላ የስጦታ ቁጥር> 300',
    receiveAll2: 'ሁሉንም "ሙቅ" ስጦታዎች ተቀበል',
    stayOn3: 'በSS-ደረጃ ለ10 ቀናት ይቆዩ',
    over5k: 'ከ 5k በላይ ደጋፊዎች',
    totalGifter3: 'ጠቅላላ የስጦታ ቁጥር > 1000',
    receiveAll3: 'ሁሉንም "የቅንጦት" ስጦታዎች ተቀበል',
    starHost6: 'የኮከብ አስተናጋጅ ዕለታዊ ተግባራት',
    dailyAssessment: '(ዕለታዊ ግምገማ ሥርዓት): መስተጋብር / ስጦታዎች',
    gcionGifts: 'Gcion ስጦታዎች',
    rulesTo: 'የኮከብ አስተናጋጅ ደረጃን ለማዋረድ ህጎች',
    failTo: 'ለ 3 ተከታታይ ቀናት የአሁኑን ደረጃ መመዘኛዎችን ማሟላት ተስኖታል።',
    failingTo: 'በሳምንት ውስጥ <span>3 ጊዜ መስፈርቶቹን ማሟላት አለመቻል',
    ifThe2: 'የእለት ተእለት ፍላጎቱን ማሟላት ያልቻለው አስተናጋጁ ሀ-ደረጃ ከሆነ፣ እርሷ/እሷ ከወራዳነት ይልቅ በቀጥታ ትባረራለች። ከተዋረደ በኋላ፣ አስተናጋጁ ደረጃውን መልሶ ለማግኘት ለ3 ተከታታይ ቀናት የዋናውን ደረጃ መመዘኛዎች ማሟላት አለበት።',
    involvementIn: 'በትላልቅ ጥሰቶች ወይም አሉታዊ ክስተቶች ውስጥ ተሳትፎ።',
    causingDamage: 'በመድረክ ፍላጎቶች ወይም የምርት ስም ምስል ላይ ጉዳት ማድረስ',
    applyFor: 'ለማቆም በራስዎ ያመልክቱ',
    liveStreaming: 'የቀጥታ ስርጭት መስፈርቶች',
    liveStream: 'የቀጥታ ዥረት ይዘት ከአስተናጋጁ ከተመደበው አይነት ጋር መመሳሰል አለበት።',
    roomHosts: 'የክፍል አስተናጋጆች በስርጭት ጊዜ ለረጅም ጊዜ ማይክሮፎናቸውን መዝጋት የተከለከሉ ናቸው።',
    liveStreams: 'የቀጥታ ዥረቶች ባለ 9 መቀመጫ ማይክሮፎን ክፍል አቀማመጥ በመጠቀም መከናወን አለባቸው።',
    otherSeats: 'በክፍሉ ውስጥ ያሉ ሌሎች መቀመጫዎች ለተግባር እርሻ ዓላማ ማይክራፎናቸውን በሚያጠፉ ተጠቃሚዎች ወይም ታዳሚዎች እንዲያዙ አይፈቀድላቸውም።',
    discriminatoryInsulting: 'በክፍል ውስጥ አድሎአዊ፣ ስድብ ወይም አፀያፊ ንግግሮች በጥብቅ የተከለከሉ ናቸው።'
  },
  starRoom: {
    afterCountdown: 'በየቀኑ ከተቆጠሩ በኋላ፣ Top3 ክፍሎች በኮከብ ክፍል ደረጃ ውስጥ ይዘረዘራሉ',
    top20Star: 'ከፍተኛ 20 ኮከብ ክፍሎች ከዚህ ሳምንት በኋላ እንደ ጥሩ ጉርሻ ይሸለማሉ።',
    countdown: 'Countdown：',
    top3Daily: 'ከፍተኛ 3 ዕለታዊ top3 ክፍሎች ሳምንታዊ የኮከብ ክፍሎችን ለመቀላቀል ብቁ ይሆናሉ',
    starRooms: 'የኮከብ ክፍሎች በሳምንቱ የመጨረሻ ቀን ይመደባሉ. በእያንዳንዱ ክፍል አጠቃላይ የሳንቲም ፍሰት መሰረት ይመደባል',
    top20Weekly: 'ምርጥ 20 ሳምንታዊ የኮከብ ክፍል ባለቤቶች እንደሚከተለው ሽልማቶችን ያገኛሉ',
    qualificationTo: 'በዚህ ዝግጅት ላይ ለመሳተፍ መመዘኛ፡ ማንኛውም ጥሰት ወይም ህገወጥ ባህሪ በክፍሉ ውስጥ አይፈቀድም፣ አንዴ ከተገኘ ሃላ ክፍሉን ውድቅ ያደርገዋል እና ከደረጃው ያስወግዳል',
    theRewards: 'ሽልማቱ በየሰኞው ይላካል።',
    days: 'days',
    coins: 'Coins'
  },
  inviteActive: {
    inviteHosts: 'አስተናጋጆችን ይጋብዙ',
    pointsMax: 'ከፍተኛው በቀን 5,000 ነጥብ',
    firstRecharge: 'የመጀመሪያ-ሞገድ ተጠቃሚዎች',
    get20: '20 ዶላር በነጻ ያግኙ',
    oneInvite: '1. የጋበዟቸው አስተናጋጆች ሲጨርሱ አስተናጋጆችን በቀጥታ እንዲጀምሩ ይጋብዙ።',
    aFinish: 'ሀ. በተግባር ማእከል ላይ የፊት ማረጋገጫን ጨርስ',
    bCreate: 'ለ. የራሷን ክፍል ፍጠር',
    cLive: 'በክፍሏ ውስጥ ለ3 ሰአታት በማይክሮፎን ኑር',
    dClaim: 'መ.የቀጥታ ሽልማቶችን ለመጀመሪያ ጊዜ ይጠይቁ',
    youGet: 'ከትክክለኛ ከተጋበዙ አስተናጋጆችዎ ቁጥሮች በየቀኑ የነጥብ ሽልማቶችን ያገኛሉ። በሚቀጥለው ቀን ሽልማቱን መጠየቅ ይችላሉ።',
    validHost: 'የሚሰራ አስተናጋጅ',
    pointsReward: 'ነጥቦች ሽልማት',
    youCan: ' You can earn up to 5,000 invite points per day',
    myInvited: 'የእኔ የተጋበዙ አስተናጋጆች',
    validHosts: 'ልክ የሆኑ አስተናጋጆች ዛሬ',
    pointsRewards: 'ነጥቦች ሽልማቶች',
    validHosts2: 'ተቀባይነት ያላቸው አስተናጋጆች ትላንት፡',
    claim: 'የይገባኛል ጥያቄ',
    claimed: 'ይገባኛል ተብሏል።',
    completedTime: 'የተጠናቀቀ ጊዜ',
    ifYour: 'ጓደኛዎችዎ በመጀመሪያ መሙላት ከጨረሱ ብዙ ሽልማቶችን ያገኛሉ።(ከመስመር ውጭ መሙላትም ይካተታል።)',
    theMore: 'የመጀመሪያው የመሙያ መጠን በጨመረ መጠን ብዙ ሳንቲሞች ይሸለማሉ እና በየቀኑ እስከ 20 ዶላር ይደርሳል።',
    inviteesRecharge: 'ተጋባዦች ሳንቲሞችን ይሞላሉ።',
    yourReward: 'የእርስዎ ሽልማት ሳንቲሞች',
    threeOnly: '3. በ30 ቀናት ውስጥ እንዲሞሉ የተጋበዙ ተጠቃሚዎች ብቻ ልክ እንደ መጀመሪያ ኃይል መሙያ ይቆጠራሉ።',
    seniorAnd: 'ከፍተኛ እና መደበኛ ሻጭ የሚቆጠሩት ከመተግበሪያው ወይም ከኦፊሴላዊው በቀጥታ ሲሞሉ ብቻ ነው (ለመክፈያ ዘዴዎች ወደ አስተዳዳሪዎ ይምጡ) ለመጀመሪያ ጊዜ ልክ እንደ መጀመሪያ ኃይል መሙያ ተጠቃሚዎች ይቆጠራሉ።',
    myInvited2: 'የእኔ የተጋበዙ ተጠቃሚዎች',
    rechargeCoins: 'ሳንቲሞችን መሙላት',
    coinsRewards: 'ሳንቲሞች ሽልማቶች',
    firstRecharge2: 'ትላንትና መጀመሪያ የሚሞሉ ሳንቲሞች፡-',
    firstRecharge3: 'መጀመሪያ የሚሞሉ ሳንቲሞች',
    firstRecharge4: 'የመጀመሪያ-መሙያ ጊዜ'
  },
  hostPolicy: {
    title: 'የአስተናጋጅ ፖሊሲ',
    section1Title: 'አዳዲስ አስተናጋጆች የመጀመሪያ ሳምንት መሰረታ ደመዝኖር',
    requirement: 'ምክንያት',
    newHostsDesc: 'በመጀመሪያ ሳምንት Hala የተቀላቀሉ አዳዲስ አስተናጋጆች',
    activeTime: 'በማይክሮፎን ላይ ንቁሳቁስ ጊዜ',
    oneHour: '1 ሰዓት',
    twoHour: '2 ሰዓታት',
    threeHour: '3 ሰዓታት',
    baseSalary: 'መሰረታ ደመዝኖር (ነጥቦች)',
    incomeRequirement: 'ገቢ ምክንያት',
    none: 'ምንም',
    remarks: 'ማስታወሻዎች',
    remarksDesc: 'ከወህ በኋላ 3 ሰዓታት መዝገብ። ከወህ 7 ቀናት። 35,000 ነጥቦች ጠቅም ጠቅም ጠቅም የላቀ ጠቅም',
    note1: 'ከአስተናጋጁ መዝገብ ቀን ጀምሮ 7 ቀን የመሰረታ ደመዝኖር የሚያበቃል ጊዜ ይጀምራል።',
    note2: 'በበርካኔዎች ወይም በብዙ አይፒ ወይም በብዙ መሣሪያዎች የሚገቡ አስተናጋጆች ከመሰረታ ደመዝኖር ሽልማት ውጭ ይደረጋሉ።',
    note3: 'የአስተናጋጁ የወርወድ 7 ቀናት ገቢ ከ150,000 ነጥቦች በላይ ከሆነ፣ እሷ የአዳዲስ አስተናጋጅ መሰረታ ደመዝኖር ሽልማት ውስጥ የተለመደ የቀጠሮ አስተናጋጅ የሰዓት ሽልማት ያገኛሉ።',
    section2Title: 'የቀጠሮ አስተናጋጅ እኩል ሽልማት',
    level: 'ደረጃ',
    incomeRequirementShort: 'ገቢ ምክንያት',
    hourlyReward: 'የሰዓት ሽልማት',
    maximumDailyHours: 'ከፍተኛ የዕለት ሰዓቶች',
    section2Note1: 'በማይክሮን ላይ በተከተለ 15 ደቂቃዎች እንደ እርምጃ ጊዜ ይካለላል።',
    section2Note2: 'ሁሉም ሽልማቶች በነጥቦች ይከፋፈላሉ እንዲሁም በስራ ስርዓቱ ላይ መጠየቅ አለባቸው።',
    section2Note3: 'የመድረክ ሽልማቶች ወደ ነጥብ ምክንያቶች አይካለኩም።',
    section2Note4: 'በብዙ አይፒ ወይም በብዙ ተችኖች ተገኝቶ ነጥቦች ይቀንሳሉ።',
    section2Note5: 'ያለፉ 7 ቀናት ያለፉ 6 ቀናት+ዛሬ ማለት ሲሆን፣ ስለዚያ ሰዓታዊ ሽልማቶችዎ በጣም ሰዓት የበለጠ የነጥብ ደረጃ ላይ ስትደርስ ሊጨምሩ ይችላሉ።',
    section2Note6: 'L-ደረጃ ያልሆነ ግብዓኛ ሽልማቶች ከመዝገብ በኋላ የመጀመሪያ 7 ቀናት ውስጥ ብቻ ይሠራሉ። 7 ቀናት በኋላ፣ አስተናጋጆች ሁል ጊዜ 500 ነፃ ነጥቦችን ማግኘት ይችላሉ።',
    section3Title: 'የአስተናጋጅ መመሪያዎች',
    regulation1: 'አስተናጋጆች በርካኔዎችን መዝገብ የሚከለው ነው።',
    regulation2: 'የሦስት ወገሽ መድረኮችን ማስተዋወቅ የሚከለው ነው።',
    regulation3: 'በጣም የገተነው የህፃናን መጠቀም ነው።',
    regulation4: 'አስተናጋጅ አንድ ብቻ የተረጋገጠ መለያ ሊኖር ይችላል። የተረጋገጡ መለያዎች ብቻ በቀጠና ሊፈስዱ እና ገቢ ሊወስዱ ይችላል።',
    regulation5: 'በቀጠና ሊፈስዱ ወይም ገቢ ሊወስዱ ለይ የአካትን ማመልከት የሚያካሂው ማንኛውም ድርጊት ለዘላለቅ ጊዜ ይከለዛል።',
    regulation6: 'ለቀጠና ስርጭቶ በአስተናጋጁ መለያ መስጠት የአስተናጋጁን መለያ በስርዓቱ ለዘላለቅ እንዲያገኝ ያደርጋል።',
    regulation7: 'በድምጽ ክፍሉ ውስጥ፣ አስተናጋጆች ወደ ክፍሉ የሚገቡ ተጠቃሚዎችን በተለመነ መንገድ መጠየቅ አለባቸው።',
    regulation8: 'የድምጽ ክፍሉ የሽፋን ፎቶ የአስተናጋጁን ትክክ እና ተማመናዊ ፎቶ መጠቀም አለበት።',
    regulation9: 'Hala መድረክ ማንኛውንም የትርቢት እንቅስቃሴዎችን በጣም ክትትል ያከለዋል። ማንኛውም ቃል ሥርዓት አለመገዛት ወደ አስተናጋጁ መለያ ለዘላለቅ ማስቀረቅ ይዳርጋል።',
    footer: 'Hala የላይቱ ፖሊሲዎች የመጨረሻ ትርጉም መብትን ይጠብቃል።',
  },
  correspondingRevenue: 'ተጓዳኝ የገቢ መስፈርቶች ከተሟሉ ነው። ሁሉም ሽልማቶች ይሰጣሉ።',
  within12: 'ክስተቱ ከጨረሰ በኋላ በ1-2 የሥራ ቀናት ውስጥ'
}
